import { state } from './state'

function post(route, data) {
  if (state.noLogging) {
    return
  }

  if (process.env.DEV_ANALYTICS) {
    route = 'http://0.0.0.0:3001' + route
  }

  fetch(route, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: "POST",
    body: JSON.stringify(data)
  })
}

export function updatePath(pathname) {
  if (state.candidateApp) {
    return
  }

  const { language, district, answers = [], weightedAnswers } = state

  const weightedAnswer = weightedAnswers && weightedAnswers[0]

  if (pathname) {
    let path = language === 'en' ? '/en/' : ''

    if (answers.length) {
      let answerPath = answers.map(answer => `${answer.question}=${answer.question === weightedAnswer ? answer.answer * 2 : answer.answer}`).join('&')
      path += `${language === 'fi' ? '/tulokset' : 'results'}?vp=${district}&${answerPath}`
    }

    window.history.pushState({ district, answers, weightedAnswers }, false, path || '/')

    logPath()
  } else {
    window.history.pushState({ district, answers, weightedAnswers }, false)
  }
}

export function logPath() {
  post('/analytics', { href: window.location.href })
}

export function sendResults(data) {
  post(window.location.pathname + '/answer', data)
}